module.exports = __webpack_public_path__ + "img/informationBlack.1d40fd4c.svg";